import React, { Component } from 'react'

export default class Typewriter extends Component {
  static defaultProps = {
    speed: 1,
    delay: 5,
    random: true,
    data: ['first', 'second', 'third', 'fourth', 'fifth'],
  }

  state = {
    query: '',
  }
  timer = ''
  handleAutoType = this.handleAutoType.bind(this)
  handleStopType = this.handleStopType.bind(this)

  handleAutoType() {
    let listIndex = 0

    this.timer = setInterval(() => {
      if (document.hasFocus()) {
        this.setState({ query: '' })
        let i = 0
        let KW
        let KW_SEARCH

        if (this.props.random) {
          KW = parseInt(Math.random() * this.props.data.length)
          KW_SEARCH = this.props.data[KW]
        } else {
          listIndex++ // start from index 1 (because initial text is index 0)
          KW_SEARCH = this.props.data[listIndex]
          //console.log(KW_SEARCH)

          if (listIndex === this.props.data.length - 1) {
            console.log('resetting')
            listIndex = -1 // reset, and then the first index is 0
          }
        }

        const typeWriter = () => {
          if (i < KW_SEARCH.length) {
            this.setState({ query: this.state.query + KW_SEARCH[i] })
            i++
            setTimeout(typeWriter, 50 / this.props.speed)
          }
        }

        typeWriter()
      }
    }, this.props.delay * 1000)
  }

  handleStopType() {
    clearInterval(this.timer)
  }

  componentWillUnmount() {
    this.handleStopType()
    this.timer = {}
  }

  componentDidMount() {
    if (this.props.initialData) {
      this.setState({ query: this.props.initialData })
    }

    this.handleAutoType()
  }

  render() {
    return this.state.query
  }
}
